import { Check, Clock, AlertTriangle, Send, FileEdit, XCircle, ArrowRightLeft } from 'lucide-react'

const CONFIG = {
  PAID:      { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', icon: Check, label: 'Paid', tip: 'Fully paid' },
  OVERDUE:   { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200', icon: AlertTriangle, label: 'Overdue', tip: 'Payment is past due — follow up with the customer' },
  PARTIAL:   { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', icon: ArrowRightLeft, label: 'Partial', tip: 'Partially paid — some balance remaining' },
  DRAFT:     { bg: 'bg-gray-50', text: 'text-gray-500', border: 'border-gray-200 border-dashed', icon: FileEdit, label: 'Draft', tip: 'Not yet approved — can still be edited' },
  APPROVED:  { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200', icon: Check, label: 'Approved', tip: 'Approved and ready to send' },
  SENT:      { bg: 'bg-indigo-50', text: 'text-indigo-700', border: 'border-indigo-200', icon: Send, label: 'Sent', tip: 'Sent to customer — awaiting payment' },
  CANCELLED: { bg: 'bg-gray-100', text: 'text-gray-500', border: 'border-gray-300', icon: XCircle, label: 'Cancelled', tip: 'This invoice has been cancelled' },
  SUBMITTED: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', icon: Clock, label: 'Submitted', tip: 'Submitted for approval' },
  REJECTED:  { bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-200', icon: XCircle, label: 'Rejected', tip: 'Rejected — check notes for reason' },
  REIMBURSED:{ bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', icon: Check, label: 'Reimbursed', tip: 'Expense reimbursed' },
  APPLIED:   { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', icon: Check, label: 'Applied', tip: 'Credit note applied to invoice' },
  DISPATCHED:{ bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', icon: Send, label: 'Dispatched', tip: 'Goods dispatched — in transit' },
  DELIVERED: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', icon: Check, label: 'Delivered', tip: 'Goods delivered to recipient' },
  OPEN:      { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200', icon: Clock, label: 'Open', tip: 'Open — not yet applied' },
}

export default function StatusBadge({ status, showIcon = true, size = 'sm' }) {
  const cfg = CONFIG[status] || { bg: 'bg-gray-100', text: 'text-gray-600', border: 'border-gray-200', icon: null, label: status, tip: '' }
  const Icon = cfg.icon
  const sizeClasses = size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs'

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${cfg.bg} ${cfg.text} ${cfg.border} ${sizeClasses}`}
      title={cfg.tip}
    >
      {showIcon && Icon && <Icon className={size === 'lg' ? 'h-3.5 w-3.5' : 'h-3 w-3'} />}
      {cfg.label}
    </span>
  )
}

export function OverdueDays({ dueDate }) {
  if (!dueDate) return null
  const days = Math.floor((Date.now() - new Date(dueDate).getTime()) / 86400000)
  if (days <= 0) return null
  return <span className="text-[10px] text-red-500 font-medium ml-1">({days}d)</span>
}
